import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";
import { ILoginRequest } from "../type/Type";
import { getCookie } from "../../../api/utils/utils";

export class LoginProvider {
  static async postLogin(payload: ILoginRequest) {
    const guestToken =
      payload.guest_token ||
      getCookie("x-guest-token") ||
      getCookie("guest-token");
    const loginPayload = guestToken
      ? { ...payload, guest_token: guestToken }
      : payload;
    return await $axios.post($api("post_login"), loginPayload);
  }
  static async postLogout() {
    return await $axios.post($api("post_logout"));
  }
}
